import React from 'react';
import { CollectionFilterSummaryProps } from '../../../models/CollectionFilter';
import { Box, Chip, styled, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const StyledChipWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
}));

const StyledFilteredTagsWrapper = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
    paddingBottom: '10px',
}));

export const CollectionFilterSummary: React.FC<CollectionFilterSummaryProps> = (
    props
) => {
    const { tags, handleTagsRemove } = props;
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS.FILTER_ITEM',
    });

    const handleDelete = (tags: string[]): void => {
        handleTagsRemove(tags);
    };

    return (
        <>
            <StyledFilteredTagsWrapper>
                {tags.length > 0 && (
                    <>
                        <div>
                            <Typography>{t('FILTERED_LABEL')}</Typography>
                        </div>
                        <div>
                            <Chip
                                label={t('DELETE_ALL')}
                                onDelete={() => handleDelete(tags)}
                                deleteIcon={<CloseIcon />}
                                color="error"
                                variant="outlined"
                                size="small"
                            />
                        </div>
                    </>
                )}
            </StyledFilteredTagsWrapper>
            <StyledChipWrapper>
                {tags.map((elem, index) => (
                    <Chip
                        key={index}
                        label={elem}
                        onDelete={() => handleDelete([elem])}
                        deleteIcon={<CloseIcon />}
                    />
                ))}
            </StyledChipWrapper>
        </>
    );
};
